type Props = {
  value: string;
  onChange: (value: string) => void;
  type?: 'date' | 'datetime-local';
  min?: string;
  max?: string;
  width?: number | string;
};

export const DateTimeInput = ({
  value,
  onChange,
  type = 'datetime-local',
  min,
  max,
  width = 250,
}: Props) => (
  <input
    type={type}
    className="form-control input-sm"
    style={{ width, maxWidth: '100%', boxSizing: 'border-box' }}
    value={value}
    min={min}
    max={max}
    onChange={(e) => onChange(e.target.value)}
  />
);
